export { default as SupplierEvaluationSlot } from './SupplierEvaluationSlot';
